// =============================================================================
// SetupScreen — four-tab admin page: Schedule / Experiences / Overrides / Locations
// =============================================================================
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ExperiencesTab } from './setup/ExperiencesTab';
import { ScheduleTab } from './setup/ScheduleTab';
import { OverridesTab } from './setup/OverridesTab';
import { LocationsTab } from './setup/LocationsTab';

type Tab = 'schedule' | 'experiences' | 'overrides' | 'locations';

const TAB_ORDER: Tab[] = ['schedule', 'experiences', 'overrides', 'locations'];
const TAB_LABEL: Record<Tab, string> = {
  schedule:    'Schedule',
  experiences: 'Experiences',
  overrides:   'Overrides',
  locations:   'Locations',
};

export function SetupScreen() {
  const [params, setParams] = useSearchParams();
  const initial = (params.get('tab') as Tab | null) ?? 'schedule';
  const [tab, setTab] = useState<Tab>(
    TAB_ORDER.includes(initial) ? initial : 'schedule',
  );

  const switchTab = (t: Tab) => {
    setTab(t);
    setParams({ tab: t });
  };

  return (
    <div className="screen setup-screen">
      <h1 className="payments-title">Setup</h1>

      <div className="edit-tabs setup-tabs">
        {TAB_ORDER.map((t) => (
          <button
            key={t}
            className={`edit-tab ${tab === t ? 'edit-tab-active' : ''}`}
            onClick={() => switchTab(t)}
          >
            {TAB_LABEL[t]}
          </button>
        ))}
      </div>

      <div className="setup-tab-body">
        {tab === 'experiences' && <ExperiencesTab />}
        {tab === 'schedule' && <ScheduleTab />}
        {tab === 'overrides' && <OverridesTab />}
        {tab === 'locations' && <LocationsTab />}
      </div>
    </div>
  );
}
